<!--
 * @Description: 综合素质评价-评价列表
 * @Author: PF
 * @Date: 2024-05-21 09:28:54
 * @LastEditors: PF
 * @LastEditTime: 2024-09-10 10:01:01
-->
<template>
  <div>
    <el-dialog class="wp85 hp85" :model-value="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Suitcase />
          </el-icon>
          <span class="header-title">评价列表</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openList', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
    <el-container>
      <el-header class="pl0 pr0">
        <!-- 搜索区域 BEGIN -->
        <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>
          <el-form-item>
            <el-select placeholder="班级" v-model="dataGrid.parms.bjid" clearable filterable @change="bindTable()">
              <el-option v-for="item in bjData" :key="item.id" :label="item.xzbmc" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select placeholder="状态" v-model="dataGrid.parms.pjzt" clearable filterable @change="bindTable()">
              <el-option label="已评" :value="true" />
              <el-option label="未评" :value="false" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input placeholder="学号/姓名/身份证件号" v-model="dataGrid.parms.keyword" clearable @clear="bindTable()" @keyup.enter="bindTable()">
              <template #suffix>
                <el-icon class="el-input__icon pointer" @click="bindTable()">
                  <search />
                </el-icon>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
        <!-- 搜索区域 END -->
      </el-header>
      <el-main class="pl0 pr0">
        <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
          <!-- 冻结列-Left BEGIN -->
          <el-table-column label="序号" type="index" width="80" fixed align="center" />
          <el-table-column label="学号" prop="xsxh" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
          <el-table-column label="学生" prop="xsxm" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
          <el-table-column label="性别" prop="xb" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
          <el-table-column label="班级" prop="bjmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
          <el-table-column label="状态" prop="pjzt" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
            <template #default="scope">
              <span v-if="scope.row.pjzt===true">已评</span>
              <span v-if="scope.row.pjzt===false">未评</span>
            </template>
          </el-table-column>
          <el-table-column label="得分" prop="zdf" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
          <!-- 冻结列-Right BEGIN -->
          <el-table-column label="操作" width="80" fixed="right" align="center">
            <template #default="scope">
              <el-button link type="success" v-if="scope.row.pjzt===false" @click="openAdd=true; tcrow={id:scope.row.id,xsxm:scope.row.xsxm,bjmc:scope.row.bjmc,xqmc:scope.row.xqmc}">评价</el-button>
              <el-button link type="success" v-if="scope.row.pjzt===true" @click="openDetail=true; tcrow=scope.row">结果</el-button>
            </template>
          </el-table-column>
          <!-- 冻结列-Right END -->
        </el-table>
      </el-main>
    </el-container>
      <template #footer>
        <div class="dialog-footer">
        <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
          <div class="footer_but">
            <el-button type="info" @click="closeWindow('openList', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
  <add v-if="openAdd" v-model:openAdd="openAdd" :row="tcrow" @ReturnData="bindTable" />
  <detail v-if="openDetail" v-model:openDetail="openDetail" :row="tcrow" />
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue'
import { loadList, loadSelect, closeWindow } from '@/api/common.js'
import pagination from '@/components/pagination.vue'
import add from './add.vue'
import detail from './detail.vue'

const props = defineProps({ openList: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])

// 加载 班级 下拉框
const bjData = ref()
const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'xsxh', order: 'ascending' }, // ['ascending', 'descending']
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map(item => (item.id))
  }
})
const bindTable = async (pageNo, pageSize) => {
  loadList({
    url: '/api/v2/xuesheng/deyupingjialiebiao/pagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    pagerCount: 5,
    dataGrid: dataGrid.value,
    loadSuccess: function () {
      dataGrid.value.multipleSelection = []
    }
  })
}
// 弹窗
const row = ref()
const tcrow = ref()
const openAdd = ref(false)
const openDetail = ref(false)

watch(
  () => props.openList,
  () => {
    if (props.openList) {
      row.value = props.row
      dataGrid.value.parms.pjglid = props.row.id
      dataGrid.value.parms.pjrlx = props.row.pjrlx
      bindTable()
      loadSelect({ url: '/api/v2/pdp/banji/list', data: bjData, order: 'xzbdm', sort: 'asc' })
    }
  },
  { deep: true, immediate: true }
)
</script>
